/**
 * @author 冷 (https://github.com/LengYXin)
 * @email lengyingxin8966@gmail.com
 * @create date 2021-11-17 13:06:25
 * @modify date 2021-11-17 13:06:25
 * @desc [微信扩展处理]
 */
import * as Mamba from '@mamba/clients';
import { Context } from '@nuxt/types';
import lodash from 'lodash';
import Vue from 'vue';
import { $AppConfig } from '../global';
import { Store } from '../store';
export const PagesWeappEnum = {
  Index: '/pages_bases/home/index',
  Login: '/pages/login/index',
  Webview: '/pages/webview/index',
  Market_live: '/pages/live/index',
  Market: '/pages_bases/market/index',
  Materials: '/pages_bases/materials/index',
  Product: '/pages_bases/product/index',
  Download: '/pages/download/index',
};
/**
 * 微信sdk 初始化
 * @export
 * @param {Context} ctx
 */
export async function WechatReady(ctx: Context) {
  if ($AppConfig.userAgent.isWechatBowser) {
    try {
      // 持久化初始化完成
      await Store.Wechat.Model.HydrateAsync;
      Store.Wechat.Model.merge(
        lodash.merge(
          {
            // 默认走 H5流程
            platform: Mamba.EnumPlatform.mobile,
          },
          lodash.pick(ctx.query, ['platform']),
        ),
      );
      // 微信认证
      await Store.Wechat.onReady(lodash.head(window.location.href.split('#')));
    } catch (error) {
      console.error(error);
    }
  } else {
    Store.Wechat.onComplete();
  }
}
Object.defineProperty(Vue.prototype, '$PagesWeapp', {
  get: lodash.constant(PagesWeappEnum),
});
declare module 'vue/types/vue' {
  interface Vue {
    readonly $PagesWeapp: typeof PagesWeappEnum;
  }
}
declare module '@nuxt/types' {
  interface Context {
    readonly $PagesWeapp: typeof PagesWeappEnum;
  }
}
